import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PopupOrPanel } from '../../components/popupsAndPanels/PopupAndPanels';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import { setMembershipOptInfo, selectMembershipOptInfo } from 'reducers/misc';
import { Spinner } from 'components/spinner/Spinner';

type Props = {
  panelOpen: boolean;
  togglePanelOpen: React.Dispatch<React.SetStateAction<boolean>>;
  submitForm: (() => Promise<void>) & (() => Promise<any>);
};

export const PupilNumMismatchModal: React.FC<Props> = ({
  panelOpen,
  togglePanelOpen,
  submitForm,
}) => {
  const dispatch = useDispatch();
  const membershipOptInfo: any = useSelector(selectMembershipOptInfo);
  
  const [loading, setLoading] = useState<boolean>(false);
  const [sliderPupilsOnRoll, setSliderPupilsOnRoll] = useState<number>(membershipOptInfo[0].pupilsOnRoll);

  const handleSubmit = () => {
    setLoading(true);

    membershipOptInfo[0].pupilsOnRoll = sliderPupilsOnRoll;
    
    dispatch(setMembershipOptInfo(membershipOptInfo));

    submitForm();

    setTimeout(function(){
      setLoading(false);
    }, 2000);
  
  };

  return (
    <PopupOrPanel
      isPopup={true}
      isOpen={panelOpen}
      hdrTitle="Pupil number mismatch"
      position="right"
      primaryBtnTxt="Apply"
      secondaryBtnTxt="Cancel"
      givenClass="PupilNumMismatch"
      primaryBtnColor="BtnOrange"
      handleClose={() => togglePanelOpen(false)}
      handlePrimaryBtn={() => handleSubmit()}
      handleSecondaryBtn={() => togglePanelOpen(false)}
      width={460}
      isSubmitting={loading}
    >
      {loading ? <Spinner /> :
        <>
          <h3>It looks like the pupil number doesn't quite match the DfE data we use</h3>
          <div className="LineSpacer4"></div>

          <div className="FormBox">
            <div className="FormLabel">Adjust pupil number</div>
            <div className="FormField">
              <div className="PupilsNoSlider">
                <div className="LeftVal">0</div>
                <div className="MiddleSlider">
                  <Slider
                    handleRender={ renderProps => (
                      <div { ...renderProps.props }>
                        <div 
                          className="PSTooltip"
                          data-slider-tooltip={ renderProps.props["aria-valuenow"] }
                        >
                          {renderProps.props["aria-valuenow"]}
                        </div>
                      </div>
                    ) }
                    max={1000}
                    onChange={(e: any) => setSliderPupilsOnRoll(e)}
                    value={sliderPupilsOnRoll}
                    step={1}
                  />
                </div>
                <div className="RightVal">1000+</div>
              </div>
            </div>
          </div>

          <p>or contact us: <a href="tel:0203 4881798">0203 4881798</a> / <a href="mailto:admin@getset4education.co.uk">admin@getset4education.co.uk</a></p>
        </>
      }
    </PopupOrPanel>
  );
};
